<template>
  <div class="page-view">
    <div class="header-view">
      <div class="logo-image" style="height: 100%; ">
        <img src="@/assets/newImage/heaader.png" class="logo-image-img">
<!--        <div class="logo-right" style=" justify-content: center;">-->
<!--          <img src="@/assets/newImage/惠收卡@3x.png" style="width: 52px;height: 16px;">-->
<!--          <img src="@/assets/newImage/www.huishouka.com@3x.png" style="width:68px;height: 7px; margin-top: 5px;">-->
<!--        </div>-->
      </div>
      <div class="header-btn">
        <el-button type="primary" @click="backAction">返回首页</el-button>
      </div>
    </div>
    <div class="content-bg">
      <img src="@/assets/newImage/千库网_世界地图剪影_元素编号12151897@2x.png" alt="" class="content-bg-image">
      <div
        style="position: absolute; top: 0px;left: 0; right: 0; bottom: 0; display: flex; flex-direction: column; align-items: center;  ">
        <div class="content-view-login">
          <img src="@/assets/newImage/查看数据@2x.png" class="content-left-image" alt=""   />
          <div class="content-right-view">
            <!-- 登录页面 -->
            <div v-if="isLoginVc == 0">
              <div class="tab-view">
                <div class="tab-item" @click="tabAction(0)">
                  <div :style="tabTag == 0 ? 'font-size: 26px;font-weight: 500;' : ' color: #000000a6;'">密码登录</div>
                    <div class="item-line" :style="tabTag == 1 ? 'background-color: white' : 'background-color: #488eff'"></div>
                </div>
                <div class="tab-item" @click="tabAction(1)" style="margin-left: 150px;">
                  <div :style="tabTag == 1 ? 'font-size: 26px;font-weight: 500;' : ' color: #000000a6;'">验证码登录</div>
                    <div class="item-line" :style="tabTag == 0 ? 'background-color: white' : 'background-color: #488eff'"></div>
                </div>
              </div>
              <div class="input-view" style="margin-top: 30px;" >
                <div class="label">登录账号</div>
                <input type="text" name="account" class="form-control" placeholder="请输入您的手机号" maxlength="11"
                  v-model="form.mobile" />
              </div>
              <div class="input-view" style="margin-top: 19px">
                <div class="label">{{ tabTag == 0 ? "登录密码" : "验证码" }}</div>
                <input type="password" name="account" class="form-control" v-model="form.password"
                  placeholder="6-20位包含字母 数字 特殊符号至少两种" maxlength="11" v-if="tabTag == 0" ref="passwordInput" />

                <input type="text" name="account" class="form-control" v-model="form.captcha" placeholder="请输入验证码"
                  maxlength="11" v-else />
                <img
                  :src="!passwordInput ? require('@/assets/newImage/可见@2x.png') : require('@/assets/newImage/不可见@2x.png')"
                  alt="" v-if="tabTag == 0" @click="onInputTypeChange('passwordInput')"
                  style="width: 18px;height:12px;" />
                <el-button type="primary" v-else @click="captcha">{{
                  isCaptchaDisabled ? `${captchaCountdown}秒后重试` : "获取验证码"
                }}</el-button>
              </div>
            </div>
            <!-- 注册页面 -->
            <div v-else-if="isLoginVc == 1">
              <div class="tab-view">
                <div class="tab-item" @click="tabAction(0)">
                  <div style="font-size: 26px;font-weight: 500;">用户注册</div>
                </div>
              </div>
              <div class="input-view" style="margin-top: 20px;">
                <div class="label">登录账号</div>
                <input type="text" name="account" class="form-control" placeholder="请输入您的手机号" maxlength="11"
                  v-model="form.mobile" />
              </div>
              <div class="input-view" style="margin-top: 19px">
                <div class="label">登录密码</div>
                <input type="password" name="account" class="form-control" placeholder="6-20位包含字母 数字 特殊符号至少两种"
                  maxlength="20" v-model="form.password" ref="passwordInput" />
                <img
                  :src="!passwordInput ? require('@/assets/newImage/可见@2x.png') : require('@/assets/newImage/不可见@2x.png')"
                  alt="" @click="onInputTypeChange('passwordInput')" style="width: 18px;height:12px;" />
              </div>
              <div class="input-view" style="margin-top: 19px">
                <div class="label">再次确认</div>
                <input type="password" name="account" class="form-control" placeholder="请输入密码" maxlength="20"
                  v-model="form.confirmPassword" ref="passwordInput1" />
                <img
                  :src="!passwordInput1 ? require('@/assets/newImage/可见@2x.png') : require('@/assets/newImage/不可见@2x.png')"
                  alt="" @click="onInputTypeChange('passwordInput1')" style="width: 18px;height:12px;" />
              </div>
              <div class="input-view" style="margin-top: 19px">
                <div class="label">验证码</div>
                <input v-model="form.captcha" type="text" name="account" class="form-control" placeholder="验证码"
                  maxlength="11" />

                <el-button type="primary" @click="captcha">{{
                  isCaptchaDisabled ? `${captchaCountdown}秒后重试` : "获取验证码"
                }}</el-button>
              </div>
            </div>
            <!-- 找回密码-->
            <div v-else>
              <div class="tab-view" style="margin-top: 70px">
                <div class="tab-item" @click="tabAction(0)">
                  <div style="font-size: 26px;font-weight: 500;">找回密码</div>
                </div>
              </div>
              <div class="input-view" style="margin-top: 20px">
                <div class="label">登录账号</div>
                <input data-v-544a96e4="" type="text" name="account" class="form-control" placeholder="请输入您的手机号"
                  maxlength="11" v-model="form.mobile" />
              </div>
              <div class="input-view" style="margin-top: 19px">
                <div class="label">登录密码</div>
                <input type="password" name="account" class="form-control" placeholder="6-20位包含字母 数字" maxlength="20"
                  v-model="form.password" ref="passwordInput" />
                <img
                  :src="!passwordInput ? require('@/assets/newImage/可见@2x.png') : require('@/assets/newImage/不可见@2x.png')"
                  alt="" @click="onInputTypeChange('passwordInput')" style="width: 18px;height:12px;" />
              </div>
              <div class="input-view" style="margin-top: 19px">
                <div class="label">再次确认</div>

                <input type="password" name="password" class="form-control" placeholder="请输入密码" maxlength="20"
                  v-model="form.confirmPassword" ref="passwordInput1" />
                <img
                  :src="!passwordInput1 ? require('@/assets/newImage/可见@2x.png') : require('@/assets/newImage/不可见@2x.png')"
                  alt="" @click="onInputTypeChange('passwordInput1')" style="width: 18px;height:12px;" />
              </div>
              <div class="input-view" style="margin-top: 19px">
                <div class="label">验证码</div>
                <input v-model="form.captcha" type="text" name="account" class="form-control" placeholder="验证码"
                  maxlength="11" />

                <el-button type="primary" @click="findCaptcha">{{
                  isCaptchaDisabled ? `${captchaCountdown}秒后重试` : "获取验证码"
                }}</el-button>
              </div>
            </div>
            <div style="
              margin-top: 30px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
              <el-checkbox v-model="checked" label="2" v-if="isLoginVc != 3">
                <span class="sub-txt">我已阅读并同意
                  <span class="txt-link" @click="gotoUser(4.2)">《用户协议》</span>
                  <span class="txt-link" @click="gotoUser(4.1)">《隐私政策》</span>
                </span>
              </el-checkbox>
              <div class="gray-link" style="flex-shrink: 0" v-if="tabTag == 0 && isLoginVc != 3" @click="isLoginVc = 3">
                忘记密码？
              </div>
              <div class="gray-link" v-if="tabTag != 0" style="color: white">
                1
              </div>
            </div>
            <div style="
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
              /* margin-top: 15px; */
            " v-if="isLoginVc != 3">
              <div class="log-btn" @click="submit">
                {{ isLoginVc == 0 ? "立即登录" : "立即注册" }}
              </div>
              <div class="sub-txt" style="margin-top: 15px" @click="switchClick">
                还没有领点回收账号？<span class="txt-link">{{
                  isLoginVc == 0 ? "立即注册" : "立即登录"
                }}</span>
              </div>
            </div>
            <div style="
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
            " v-else>
              <div class="log-btn" @click="findPassword">立即找回</div>
            </div>
          </div>

        </div>
        <div class="footer-nav">
          <div class="nav-links">
            <a @click="gotoUser(4.1)">政策隐私</a>
            <span class="divider">|</span>
            <a @click="gotoUser(4.2)">注册协议</a>
            <span class="divider">|</span>
            <a @click="gotoUser(4.4)">转让协议</a>
            <span class="divider">|</span>
            <a @click="gotoUser(4.3)">免责声明</a>
          </div>
          <div class="copyright">
            Copyright © 版权所有 河北领点枫科技有限公司 冀ICP备2025135202号-1
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
import Cokie from "js-cookie";

export default {

  mounted() {
    document.addEventListener('touchstart', function (event) {
      event.preventDefault();
    }, { passive: false });

    document.addEventListener('gesturestart', function (event) {
      event.preventDefault();
    });
  },
  beforeDestroy() {
    document.removeEventListener('touchstart', function (event) {
      event.preventDefault();
    }, { passive: false });
    document.removeEventListener('gesturestart', function (event) {
      event.preventDefault();
    });
  },
  data() {
    return {
      passwordInput: true,
      passwordInput1: true,
      isEyeOpen: false,
      tabTag: 0,
      isLoginVc: 0,
      form: {},
      checked: false,
      passwordRegex: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/,
      captchaCountdown: 60,
      isCaptchaDisabled: false,
    };
  },
  mounted() { },
  methods: {
    gotoUser(vl) {
      console.log('gotoUser called with vl:', vl);
      // 设置store状态并跳转到HelpCentre页面
      this.$store.commit("changedMenuId", 4);
      this.$store.commit("changedLeftChildId", vl);
      console.log('Store state after commit - menuIdX:', this.$store.state.menuIdX, 'leftChildIdX:', this.$store.state.leftChildIdX);

      // 使用nextTick确保store状态更新后再跳转
      this.$nextTick(() => {
        this.$router.push("/HelpCentre");
      });
    },

    // 返回首页
    backAction() {
      this.$router.push("/");
    },
    // 明文暗文切换：
    onInputTypeChange(refName) {
      if (refName == 'passwordInput') {
        this.passwordInput = !this.passwordInput;
      } else {
        this.passwordInput1 = !this.passwordInput1;
      }
      this.$refs[refName].type =
        this.$refs[refName].type === "text" ? "password" : "text";
    },
    // 切换登录方式
    tabAction(vl) {
      this.tabTag = vl;
    },
    // 切换注册登录
    switchClick() {
      this.isLoginVc = this.isLoginVc == 0 ? 1 : 0;
    },
    // 提交事件
    submit() {
      this.form.platform = 3;
      if (this.isLoginVc == 0) {
        this.login();
      } else {
        this.register();
      }
    },
    // 获取验证码
    captcha() {
      if (this.isCaptchaDisabled) return;
      // 先验证手机号格式
      if (!/^1[3-9]\d{9}$/.test(this.form.mobile)) {
        this.$message.error("请输入有效的手机号码");
        return;
      }
      this.startCaptchaCountdown();
      if(this.isLoginVc == 1){  //注册
        http
        .get("/user/register/captcha?mobile=" + this.form.mobile)
        .then((response) => {
          if (response.code == 200) {
            this.$message.success("短信发送成功");
          } else {
            this.$message.error(response.msg);
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });

      }else{  //登录
        http
        .get("/user/login/captcha?mobile=" + this.form.mobile)
        .then((response) => {
          if (response.code == 200) {
            this.$message.success("短信发送成功");
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
      }
    },
    // 找回密码验证码
    findCaptcha() {
      if (this.isCaptchaDisabled) return;
      // 先验证手机号格式
      if (!/^1[3-9]\d{9}$/.test(this.form.mobile)) {
        this.$message.error("请输入有效的手机号码");
        return;
      }
      this.startCaptchaCountdown();
      http
        .get("/user/find/captcha?mobile=" + this.form.mobile)
        .then((response) => {
          if (response.code == 200) {
            this.$message.success("短信发送成功");
          } else {
            this.$message.error(response.msg);
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
    // 找回密码
    findPassword() {
      // 先验证手机号格式
      if (!/^1[3-9]\d{9}$/.test(this.form.mobile)) {
        this.$message.error("请输入有效的手机号码");
        return;
      }
      if (!this.passwordRegex.test(this.form.password)) {
        this.$message.error(
          "密码必须是6-20位，包含字母和数字"
        );
        return;
      }
      if (this.form.password !== this.form.confirmPassword) {
        this.$message.error("两次输入的密码不一致");
        return;
      }
      if (!this.form.captcha) {
        this.$message.error("请输入验证码");
        return;
      }
      let data = this.form;
      data.platform = 3
      http
        .post("/user/find/pwd", data)
        .then((response) => {
          if (response.code == 200) {
            this.$message("修改成功");
            this.isLoginVc = 0;
          } else {
            this.$message.error(response.msg);
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },

    //注册
    register() {
      // 先验证手机号格式
      if (!/^1[3-9]\d{9}$/.test(this.form.mobile)) {
        this.$message.error("请输入有效的手机号码");
        return;
      }
      if (!this.passwordRegex.test(this.form.password)) {
        this.$message.error("密码必须是6-20位，包含字母和数字");
        return;
      }
      if (this.form.password !== this.form.confirmPassword) {
        this.$message.error("两次输入的密码不一致");
        return;
      }
      if (!this.form.captcha) {
        this.$message.error("请输入验证码");
        return;
      }
      http
        .post("/user/register", this.form)
        .then((response) => {
          if (response.code == 200) {
            this.$message.success("注册成功");
            this.isLoginVc = 0;
          } else {
            this.$message.error(response.msg);
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
    //登录
    login() {
      // 先验证手机号格式
      if (!/^1[3-9]\d{9}$/.test(this.form.mobile)) {
        this.$message.error("请输入有效的手机号码");
        return;
      }


      if (this.tabTag == 0) {
        if (!this.form.password) {
          this.$message.error("请输入密码");
          return;
        }
      } else {
        if (!this.form.captcha) {
          this.$message.error("请输入验证码");
          return;
        }
      }
      if (!this.checked) {
        this.$message.error("请阅读并同意用户协议和隐私政策");
        return;
      }
    if(this.tabTag == 0){
      http
        .post("/user/login", this.form)
        .then((response) => {
          if (response.code == 200) {
            Cokie.set("token", response.token);
            Cokie.set("phone", this.form.mobile);
            this.$message.success("登录成功");
            this.$router.replace("/");
          } else {
            this.$message.error(response.msg);
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });

    }else{
      http
        .post("/user/captcha/login", this.form)
        .then((response) => {
          if (response.code == 200) {
            Cokie.set("token", response.token);
            Cokie.set("phone", this.form.mobile);
            this.$message.success("登录成功");
            this.$router.replace("/");
          } else {
            this.$message.error(response.msg);
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    }

    },
    // 开始倒计时
    startCaptchaCountdown() {
      this.isCaptchaDisabled = true;
      let countdown = this.captchaCountdown;
      const interval = setInterval(() => {
        countdown--;
        if (countdown <= 0) {
          clearInterval(interval);
          this.isCaptchaDisabled = false;
          this.captchaCountdown = 60; // 重置倒计时
        } else {
          this.captchaCountdown = countdown;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.log-btn {
  width: 360px;
  height: 54px;
  background-color: #488eff;
  border-radius: 15px;
  line-height: 54px;
  text-align: center;
  color: white;
  margin-top: 35px;
}

.page-view {

  background: #E8F6FF;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  .header-view {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white;
    position: fixed;
    padding: 0px 17px;
    top: 0;
    left: 0;
    right: 0;

    .logo-image {
      height: 44px;
      width: 154px;
    }

    .header-btn {
      display: flex;
      align-items: center;
    }
  }

  .content-bg {
    flex: 1;
    margin-top: 64px;
    background: #E8F6FF;
    position: relative;
    padding-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: calc(100vh - 64px); // 设置最小高度
    height: auto;

    .footer-nav {
      margin-top: 10px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // gap: 15px;


      .nav-links {
        display: flex;
        align-items: center;
        gap: 15px;
        color: #333;
        font-size: 14px;

        .divider {
          padding: 0px 5px;
          color: #333;
        }

        a {
          color: #333;
          text-decoration: none;
          cursor: pointer;
          font-size: 14px;

          &:hover {
            color: #488eff;
          }
        }
      }

      .copyright {
        margin-top: 8px;
        color: #666;
        font-size: 12px;
        text-align: center;
      }
    }

    .content-bg-image {
      width: 100vw;
      max-height: 550px;
      min-width: 650px;

    }

    .content-view-login{
      margin-top: 50px; // 添加自动高度
      min-height: 550px;
      width: 1222px;
      min-width: 1222px;
      display: flex;
      box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.05), 0px 5px 5px -3px rgba(0, 0, 0, 0.1);
      border-radius: 22px;
      background-color: white;
      border: 1px solid #DCDCDC;
      padding-bottom: 20px;

      .content-left-image {
        height: 550px;
        left: 0;
        top: 0;
        width: 50%;
        margin-right: 100px;
        border-radius: 20px;
      }

      .content-right-view {
        padding-right: 50px;
        width: 50%; // 添加固定宽度
        box-sizing: border-box;

        .tab-view {
          margin-top: 50px;
          display: flex;
          align-items: center;
          width: 100%;
          justify-content: center;

          .tab-item {
            font-size: 24px;
            font-weight: 400;
            display: flex;
            flex-direction: column;
            align-items: center;

            .item-line {
              background-color: #488eff;
              border-radius: 8px 8px 0 0;
              height: 6px;
              left: 50%;
              width: 54px;
              margin-top: 5px;
            }
          }
        }

        .input-view {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e0e0e0;
          height: 55px;
          width: 100%; // 确保宽度100%
          box-sizing: border-box;
          margin-top: 19px; // 统一上边距

          &:first-child {
            margin-top: 20px; // 第一个输入框的上边距
          }

          .label {
            color: #000000e0;
            font-size: 18px;
            font-weight: 500;
            line-height: 28px;
            min-width: 80px;
            flex-shrink: 0; // 防止label缩小
          }

          .form-control {
            flex: 1;
            background: none;
            border: 0;
            box-sizing: border-box;
            color: #000000e0;
            font-size: 18px;
            font-weight: 400;
            height: 100%;
            min-width: 0;
            outline: none;
            padding: 0 30px;
          }
        }
      }
    }
  }
}

input::-webkit-input-placeholder {
  font-size: 14px;
}

.sub-txt {
  font-size: 14px;
  font-weight: 400;
}

.gray-link {
  font-size: 14px;
  color: #505050;
  margin-right: 10px;

}

// 移除内联样式
div[style*="margin-top: 20px;background-color: red;"] {
  background-color: transparent !important; // 移除红色背景
  margin-top: 20px;
}

div[style*="margin-top: 20px;background-color: yellow;"] {
  background-color: transparent !important; // 移除黄色背景
  margin-top: 20px;
}
</style>
